export default "__VITE_ASSET__066e080e__"